import React, { useState } from 'react';
import styles from './ReactExamDetailsPage.module.css';

const ReactExamDetailsPage = () => {
    const [showCertificationDetails, setShowCertificationDetails] = useState(false);

    const handleLearnMoreClick = () => {
        setShowCertificationDetails(!showCertificationDetails);
    };

    return (
        <div className={styles.examContainer}>
            <h1>React Professional Exam Outline</h1>
            <section className="about-exam">
                <h2>About the React Professional Exam</h2>
                <p>
                The Exam is designed for individuals seeking to solidify their foundational understanding of React, a critical skill for modern web development. This exam targets those who are either new to React or looking to formalize their knowledge and expertise in this powerful JavaScript library. Achieving certification in React Essentials gives employers confidence in your ability to build, maintain, and optimize React applications, enhancing your potential for roles in front-end development, application development, and other related fields.
                </p>
            </section>
            
            <section className="topics-covered">
              <h2>Topics Covered in the React Essentials Exam</h2>
              <ul className="no-bullets">
                <li>Fundamentals
                  <ul>
                    <li>Identify React Application.</li>
                    <li>Utilize React toolkit.</li>
                    <li>Set up local server.</li>
                    <li>Install third-party libraries.</li>
                    <li>Create initial React application.</li>
                  </ul>
                </li>
                <li>JSX and Rendering Components
                  <ul>
                    <li>Utilize React DOM.</li>
                    <li>Determine use for class versus functional components.</li>
                    <li>Utilize nesting of components.</li>
                  </ul>
                </li>
                <li>State and Props
                  <ul>
                    <li>Utilize different methods for storing state.</li>
                    <li>Use state and /or props to interact with other components.</li>
                    <li>Pass props to child components.</li>
                    <li>Render a condition-based state.</li>
                  </ul>
                </li>
                <li>Events
                  <ul>
                    <li>Utilize life-cycle events.</li>
                    <li>Use hook events for accessing, storing data.</li>
                    <li>Script an on-change event.</li>
                    <li>Manipulate components through events.</li>
                  </ul>
                </li>
                <li>List and Keys
                  <ul>
                    <li>Utilize the map function to create a list.</li>
                    <li>Extract components with key.</li>
                  </ul>
                </li>
                <li>Styling and Styling Components
                  <ul>
                    <li>Employ style components.</li>
                    <li>Integrate style components into application.</li>
                  </ul>
                </li>
                <li>Forms and Controlled Components
                  <ul>
                    <li>Use state to handle form values.</li>
                    <li>Implement control components in fields.</li>
                    <li>Use life-cycle events to load forms.</li>
                    <li>Send form data to external application.</li>
                    <li>Utilize call back function.</li>
                  </ul>
                </li>
                <li>React Router
                  <ul>
                    <li>Use React Router to add new pages and URL.</li>
                    <li>Set up security parameter to secure user routes.</li>
                    <li>Pass State and Props to route.</li>
                  </ul>
                </li>
              </ul>
            </section>

            <section className="exam-info">
              <h2>React Professional Developer Examination Information</h2>
              <table>
                <tbody>
                  <tr>
                    <td>Length of exam</td>
                    <td>60 minutes</td>
                  </tr>
                  <tr>
                    <td>Number of items</td>
                    <td>90</td>
                  </tr>
                  <tr>
                    <td>Item format</td>
                    <td>Multiple choice</td>
                  </tr>
                  <tr>
                    <td>Passing Score</td>
                    <td>73%</td>
                  </tr>
                  <tr>
                    <td>Exam language availability</td>
                    <td>English</td>
                  </tr>
                  <tr>
                    <td>Testing options</td>
                    <td>Online Testing</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="exam-weights">
              <h2>React Professional Developer Examination Weights</h2>
              <table>
                <thead>
                  <tr>
                    <th>Domain</th>
                    <th>Task</th>
                    <th>Recommended % of test by Domain</th>
                    <th>Recommended # of questions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Components</td>
                    <td>
                      <ul>
                        <li>Identify the basic structure of React components.</li>
                        <li>Utilize state and props within components.</li>
                        <li>Apply event handlers for user interactions.</li>
                        <li>Declare and use lifecycle methods and hooks.</li>
                        <li>Utilize the Context API.</li>
                      </ul>
                    </td>
                    <td>32%</td>
                    <td>29</td>
                  </tr>
                  <tr>
                    <td>State Management</td>
                    <td>
                      <ul>
                        <li>Define state management using hooks.</li>
                        <li>Implement context for global state management.</li>
                        <li>Utilize external state management libraries like Redux.</li>
                      </ul>
                    </td>
                    <td>11%</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Event Handling</td>
                    <td>
                      <ul>
                        <li>Implement event handlers for various user interactions.</li>
                        <li>Utilize synthetic events for consistent event handling.</li>
                        <li>Manage form events and submissions.</li>
                      </ul>
                    </td>
                    <td>11%</td>
                    <td>10</td>
                  </tr>
                  <tr>
                    <td>Lifecycle Methods and Hooks</td>
                    <td>
                      <ul>
                        <li>Recognize React component lifecycle methods.</li>
                        <li>Apply good practices for using hooks.</li>
                        <li>Utilize hooks for managing side effects and performance.</li>
                      </ul>
                    </td>
                    <td>6%</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td>Rendering and Performance</td>
                    <td>
                      <ul>
                        <li>Create and optimize React components for performance.</li>
                        <li>Utilize keys for efficient rendering of lists.</li>
                        <li>Implement memoization techniques to optimize performance.</li>
                      </ul>
                    </td>
                    <td>14%</td>
                    <td>13</td>
                  </tr>
                  <tr>
                    <td>Routing</td>
                    <td>
                      <ul>
                        <li>Implement routing using React Router.</li>
                        <li>Manage navigation and dynamic routing in a React application.</li>
                        <li>Handle nested routes and route parameters.</li>
                      </ul>
                    </td>
                    <td>8%</td>
                    <td>7</td>
                  </tr>
                  <tr>
                    <td>Testing</td>
                    <td>
                      <ul>
                        <li>Use testing libraries like Jest and React Testing Library.</li>
                        <li>Implement unit tests for React components.</li>
                        <li>Write integration tests for React applications.</li>
                      </ul>
                    </td>
                    <td>5%</td>
                    <td>4</td>
                  </tr>
                  <tr>
                    <td>Styling</td>
                    <td>
                      <ul>
                        <li>Style components using CSS-in-JS libraries like styled-components.</li>
                        <li>Apply global styles using CSS or pre-processors like SASS.</li>
                        <li>Use utility-first CSS frameworks like Tailwind CSS.</li>
                      </ul>
                    </td>
                    <td>14%</td>
                    <td>13</td>
                  </tr>
                </tbody>
              </table>
            </section>

            {/* <button onClick={handleLearnMoreClick} className={styles.learnMoreButton}>
                Learn More
            </button>

            {showCertificationDetails && (
                <section className="certification-details">
                    <h2>React.JS Framework
                    Certification Scheme</h2>
                    <h3>Description of Role</h3>
                    <p>React.JS Framework Developer builds applications with React. React is a popular open-source
                    JavaScript library used for building user interfaces, single-page applications where efficient and
                    dynamic rendering of components is required. Professionals in this role have an in-depth
                    knowledge of encapsulated components for the React work such as but not limited to Virtual
                    Document Object Model (DOM), JavaScript XML (JSX) syntax extension, declarative programming,
                    unidirectional data flow, and state management.</p>
                    <h3>Certification Target Audience</h3>
                    <p>Open to all individuals preparing to enter in or continue in the Information Technology field as a
                    web designer or app developer</p>
                    <h3>Certification Eligibility Requirements</h3>
                    <p>None: anyone can register to take the React Professional certification.</p>
                    <h3>Recommended</h3>
                    <p>Familiar with the use of a desktop or laptop computer and the Internet. Use Windows or Mac operating systems.</p>
                    <h3>Initial Certification Requirements</h3>
                    <p>Agree to comply with certification rules (security, confidentiality, etc.)
                    Pass certification exam.</p>
                    <h3>Maintenance Requirements</h3>
                    <p>Agree to comply with certification rules (security, confidentiality, etc.)</p>
                    <h3>Certification Term</h3>
                    <p>3 years</p>
                    <h3>Recertification Requirements</h3>
                    <p>Objective: To ensure continued proficiency and updated knowledge in frameworks that support JavaScript.</p>
                    <ul>
                        <li>Agree to comply with certification rules (security, confidentiality, etc.)</li>
                        <li>Submit evidence of 20 units of continuing education or pass the current version of the examination</li>
                    </ul>
                    <h3>Certification Test Content Outline</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Domain</th>
                                <th>Task</th>
                                <th>Current % of Test</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Fundamentals</td>
                                <td>
                                    <ul>
                                        <li>Identify React application.</li>
                                        <li>Utilize React toolkit</li>
                                        <li>Set up a local server.</li>
                                        <li>Install third-party libraries.</li>
                                        <li>Create initial React application.</li>
                                    </ul>
                                </td>
                                <td>43%</td>
                            </tr>
                            <tr>
                                <td>JSX and Rendering Components</td>
                                <td>
                                    <ul>
                                      <li>Utilize React DOM.</li>
                                      <li>Determine use for class versus functional components.</li>
                                      <li>Utilize nesting of components.</li>
                                    </ul>
                                </td>
                                <td>18%</td>
                            </tr>
                            <tr>
                                <td>State and Props</td>
                                <td>
                                  <ul>
                                    <li>Utilize different methods for storing state.</li>
                                    <li>Use state and /or props to interact with other components.</li>
                                    <li>Pass props to child components.</li>
                                    <li>Render a condition-based state.</li>
                                  </ul>
                                </td>
                                <td>10%</td>
                            </tr>
                            <tr>
                                <td>Events</td>
                                <td>
                                    <ul>
                                      <li>Utilize life-cycle events.</li>
                                      <li>Use hook events for accessing, storing data.</li>
                                      <li>Script an on-change event.</li>
                                      <li>Manipulate components through events.</li>
                                    </ul>
                                </td>
                                <td>4%</td>
                            </tr>
                            <tr>
                                <td>List and Keys</td>
                                <td>
                                    <ul>
                                      <li>Utilize the map function to create a list.</li>
                                      <li>Extract components with key.</li>
                                    </ul>
                                </td>
                                <td>11%</td>
                            </tr>
                            <tr>
                                <td>Styling and Styling Components</td>
                                <td>
                                  <ul>
                                    <li>Employ style components.</li>
                                    <li>Integrate style components into application.</li>
                                  </ul>
                                </td>
                                <td>4%</td>
                            </tr>
                            <tr>
                                <td>Forms and Controlled Components</td>
                                <ul>
                                  <li>Use state to handle form values.</li>
                                  <li>Implement control components in fields.</li>
                                  <li>Use life-cycle events to load forms.</li>
                                  <li>Send form data to external application.</li>
                                  <li>Utilize call back function.</li>
                                </ul>
                                <td>4%</td>
                            </tr>
                            <tr>
                                <td>React Router</td>
                                <td>
                                    <ul>
                                      <li>Use React Router to add new pages and URL.</li>
                                      <li>Set up security parameter to secure user routes.</li>
                                      <li>Pass State and Props to route.</li>
                                    </ul>
                                </td>
                                <td>5%</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            )} */}
        </div>
    );
};

export default ReactExamDetailsPage;